<div *ngIf="whatsappLink && webview == false">   
    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css">
    <a [href]="whatsappLink" class="float" target="_blank">
        <i class="fa fa-whatsapp my-float"></i>
    </a>
</div>

